import '../../scss/components/_clipboard-copy.scss';

export class ClipboardCopy {
  constructor (target) {
    this.section = target;
  }

  init () {
    function createToast(btn) {
      const toastMsg = document.createElement('div');
      const copyText = btn.dataset.url;
      const keepText = document.createElement('input');

      keepText.setAttribute('value', copyText);
      document.body.appendChild(keepText);
      keepText.select();
      document.execCommand('copy');
      document.body.removeChild(keepText);
      toastMsg.className = 'toast';
      toastMsg.innerHTML = '<span>Copied</span>';
      btn.parentElement.appendChild(toastMsg);

      toastMsg.timeoutId = setTimeout(() => toastMsg.remove(), 2000);
    }

    this.section.addEventListener('click', () => createToast(this.section));

    this.loading(false);
  }

  loading(isLoading = true) {
    this.section.classList.toggle('loading', isLoading);
  }
}
